var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',[_c('ListSuggestionConversations',{style:({ overflowX: 'auto', flexGrow: 2, marginTop: '-40px' }),attrs:{"suggestionID":parseInt(_vm.suggestionID)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }